import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/cal-ay/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
